export type TurnStep = 'announce' | 'respond' | 'outcome' | 'next';

const STEPS: { id: TurnStep; label: string }[] = [
  { id: 'announce', label: 'Narrator announces' },
  { id: 'respond', label: 'You respond' },
  { id: 'outcome', label: 'Outcome' },
  { id: 'next', label: 'Next scene' },
];

/** The four beats of every scene, with the current one lit, plus the single thing to do right now. */
export function TurnSteps({ step, prompt }: { step: TurnStep; prompt: string }) {
  const at = STEPS.findIndex((s) => s.id === step);
  return (
    <div className="turn-steps" aria-label="Turn structure">
      <ol className="turn-steps__list">
        {STEPS.map((s, i) => (
          <li key={s.id} className={`turn-step ${i === at ? 'turn-step--now' : ''} ${i < at ? 'turn-step--done' : ''}`} aria-current={i === at ? 'step' : undefined}>
            <span className="turn-step__n">{i + 1}</span> {s.label}
          </li>
        ))}
      </ol>
      <p className="turn-prompt" role="status">
        {prompt}
      </p>
    </div>
  );
}
